import { RecallIntegrationService } from '../services/vault-auth';
import type { ConnectRecallRequest } from '../services/vault-auth';

export type GoogleConnectPayload = ConnectRecallRequest;

export const googleConnect = (payload: GoogleConnectPayload) => {
  return RecallIntegrationService.connectRecallConnectRecallPost(payload);
};
